/**
 * Rotation aléatoire des images de cartes événements
 */
export function initEventCardRotation(root = document) {
  const containers = root.querySelectorAll('.event-list__event__image');

  if (containers.length === 0) {
    return;
  }

  const randomRotation = (range) => (Math.random() * range * 2 - range).toFixed(2);

  containers.forEach(container => {
    const target = container.classList.contains('placeholder-poster')
      ? container
      : container.querySelector('img');
    if (!target) {
      return;
    }

    const hoverZone = container.closest('.event-list__event') || container;

    // Initial
    target.style.setProperty('--rotation', `${randomRotation(2)}deg`);
    target.style.setProperty('--scale', '1');

    hoverZone.addEventListener('mouseenter', () => {
      const hoverRotation = randomRotation(2);
      target.style.setProperty('--rotation', `${hoverRotation}deg`);
      target.style.setProperty('--scale', '1.025');
    });

    hoverZone.addEventListener('mouseleave', () => {
      const leaveRotation = randomRotation(1.5);
      target.style.setProperty('--rotation', `${leaveRotation}deg`);
      target.style.setProperty('--scale', '1');
    });
  });
}
